module.exports = __webpack_public_path__ + "static/media/Racket-logo.b0728c2f.svg";